module.exports = __webpack_public_path__ + "static/media/Formular-Black.775ccd45.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Formular-Black.woff2
// module id = 279
// module chunks = 0